import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CalendarEventDates.module.css";
import chevron from "./chevron.png";
import { useState, useEffect } from "react";

/**
 * Interactive component. A calendar that shows event dates.
 */
export function CalendarEventDates({
  allowPastDate,
  eventsDate,
  onMonthChange,
}) {
  const [currentMonth, setMonth] = useState(null);
  const [currentYear, setYear] = useState(null);
  const [days, setDays] = useState([]);
  const [today, setToday] = useState(null);
  const [dateEvents, setDateEvents] = useState([]);

  useEffect(() => {
    var d = new Date();
    setMonth(d.getMonth());
    setYear(d.getFullYear());
  }, []);

  useEffect(() => {
    if (currentMonth != null && currentYear != null) {
      setDays(getDays(currentMonth + 1, currentYear));
    }
  }, [currentMonth, currentYear]);

  useEffect(() => {
    // Set today's date
    setToday(new Date());

    //Parse the event date
    if (eventsDate) {
      let parsedDates = [];
      eventsDate.forEach((date) => {
        var parsedDate = new Date(date);
        parsedDates.push({
          year: parsedDate.getFullYear(),
          month: parsedDate.getMonth(),
          day: parsedDate.getDate(),
        });
      });
      setDateEvents(parsedDates);
    }
  }, [eventsDate]);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function incrementMonth() {
    var nextMonthDate = new Date(currentMonth + 1 + "/01/" + currentYear);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    setMonth(nextMonthDate.getMonth());
    setYear(nextMonthDate.getFullYear());

    if (onMonthChange) {
      onMonthChange(nextMonthDate);
    }
  }

  function decrementMonth() {
    var lastMonthDate = new Date(currentMonth + 1 + "/01/" + currentYear);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    setMonth(lastMonthDate.getMonth());
    setYear(lastMonthDate.getFullYear());

    if (onMonthChange) {
      onMonthChange(lastMonthDate);
    }
  }

  function isDateBeforeToday(date) {
    if (allowPastDate !== true) {
      var todaysDate = new Date();
      if (date.getTime() < todaysDate.getTime()) {
        if (
          date.getYear() == todaysDate.getYear() &&
          date.getMonth() == todaysDate.getMonth() &&
          date.getDate() == todaysDate.getDate()
        ) {
          return false;
        }
        return true;
      }
      return false;
    }
  }

  function getDays(month, year) {
    var currentDate = new Date(month + "/01/" + year);

    if (currentDate.getDay() != 1) {
      while (currentDate.getDay() != 1) {
        // making sure we start on a monday
        currentDate.setDate(currentDate.getDate() - 1);
      }
    }

    var d = [];
    for (var i = 0; i < 35; i++) {
      let isToday = false;
      if (today) {
        isToday =
          currentDate.getDate() === today.getDate() &&
          currentDate.getMonth() === today.getMonth() &&
          currentDate.getFullYear() === today.getFullYear();
      }

      const isEventDate = dateEvents.some(
        (event) =>
          event.day === currentDate.getDate() &&
          event.month === currentDate.getMonth() &&
          event.year === currentDate.getFullYear()
      );

      d.push({
        day: currentDate.getDate(),
        month: currentDate.getMonth(),
        year: currentDate.getFullYear(),
        dateString: currentDate.toLocaleDateString(),
        grayedOut: currentDate.getMonth() != month - 1,
        disabled: isDateBeforeToday(currentDate),

        isToday,
        isEventDate,
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return d;
  }

  return (
    <div className={classNames(styles.container)}>
      <img
        src={chevron}
        className={classNames(styles.arrow, styles.rightArrow)}
        onClick={() => incrementMonth()}
      />
      <img
        src={chevron}
        className={classNames(styles.arrow, styles.leftArrow)}
        onClick={() => decrementMonth()}
      />

      <div className={classNames(styles.monthYear)}>
        {monthNames[currentMonth] + " " + currentYear}
      </div>

      <div className={styles.grid}>
        <div className={styles.gridItem}>Mo</div>
        <div className={styles.gridItem}>Tu</div>
        <div className={styles.gridItem}>We</div>
        <div className={styles.gridItem}>Th</div>
        <div className={styles.gridItem}>Fr</div>
        <div className={styles.gridItem}>Sa</div>
        <div className={styles.gridItem}>Su</div>

        {days.map((day, index) => (
          <div
            key={index}
            className={classNames(
              styles.gridItem,
              styles.days,
              day.grayedOut ? styles.grayedOut : "",
              day.disabled ? styles.disabled : "",

              day.isToday ? styles.today : "",
              day.isEventDate ? styles.eventDates : ""
            )}
            onClick={() => {}}
          >
            {day.day}
          </div>
        ))}
      </div>
    </div>
  );
}

CalendarEventDates.propTypes = {
  allowPastDate: PropTypes.bool,
  eventsDate: PropTypes.arrayOf(PropTypes.string),
  onMonthChange: PropTypes.func,
};
